@import 'styles/mixins';
@import 'styles/variables';

.button {
  display: flex;
  align-items: center;
  padding: 2px;

  &:not([disabled]):hover {
    .checkmark {
      stroke: var(--neutral-10);
    }
  }

  &.checked,
  &:not([disabled]).checked:hover {
    .checkmark {
      stroke: var(--neutral-30);
    }
  }

  &.task {
    padding: 1px;
  }
}

.checkboxContainer {
  display: flex;

  .taskIcon {
    @include transition(0.1s);
  }

  &.enter .taskIcon,
  &.exit .taskIcon {
    transform: scale(1);
  }
  &.enterActive .taskIcon,
  &.exitActive .taskIcon {
    transform: scale(1.125);
  }
}

.squareIcon {
  .showOnHover {
    transition: opacity ease-in-out 200ms;
    opacity: 0;
  }

  .squareIconBorder {
    transition: stroke ease-in-out 200ms;
    stroke: var(--neutral-30);
  }

  &:hover {
    .showOnHover {
      opacity: 1;
    }

    .squareIconBorder {
      stroke: var(--neutral-40);
    }

    .squareIconBorderCompleted {
      stroke: var(--neutral-30);
    }
  }
}

.taskIcon {
  & path {
    transition: fill ease-in-out 200ms;
    fill: transparent;
  }

  &:hover {
    & path {
      fill: var(--neutral-30);
    }
  }
}

.taskIcon {
  & path {
    transition: fill ease-in-out 200ms;
    fill: transparent;
  }

  &:hover {
    & path {
      fill: var(--neutral-30);
    }
  }

  rect:first-child {
    fill: transparent;
  }

  g {
    rect:nth-child(1) {
      fill: var(--neutral-0);
    }

    rect:nth-child(2) {
      stroke: var(--neutral-30);
    }
  }

  &.completedTaskIcon {
    rect:first-child {
      fill: var(--neutral-10);
    }

    g {
      rect:nth-child(1) {
        fill: var(--neutral-30);
      }

      rect:nth-child(2) {
        stroke: var(--neutral-30);
      }
    }
  }
}

.completedTaskIcon {
  & path {
    fill: var(--neutral-0);
    transition: opacity ease-in-out 200ms;
    opacity: 1;
  }

  .showOnHover {
    transition: opacity ease-in-out 200ms;
    opacity: 0;
  }

  &:hover {
    & path {
      fill: var(--neutral-0);
    }
  }
}

.checkmark {
  transition: stroke ease-in-out 200ms;
  stroke: none;
}

.label {
  margin-left: 8px;
}

.readOnly {
  cursor: auto;

  &:hover {
    & path {
      fill: var(--neutral-0);
    }
  }

  .taskIcon {
    &:hover {
      & path {
        fill: var(--neutral-0);
      }
    }
  }
}
